import React from 'react';
import { LeadFunnel } from './components/funnel/LeadFunnel';

function App() {
  return (
    <LeadFunnel />
  );
}

export default App;